import { AddGroupController } from '../views/administration/accountGroups/AddGroupController';
import { DeleteConfirmationController } from '../views/delete/DeleteConfirmationController';
import { ConfirmationModalController } from '../components/modal/ConfirmationModalController';
import { fsLoginController } from '../views/login/login';
import { DashBoardController } from '../views/dashboard/dashboard';
import { arsAccountsController } from '../views/accounts/overview';
import { MainController } from './Main';
import { AccountController } from '../views/accounts/AccountController';
import { StatementController } from './StatementController';
import { SendReportingDeleteConfirmationController } from '../views/administration/reporting/SendReportingDeleteConfirmationController';
import { ReportModalController } from '../components/report/ReportModalController';
import { ExportModalController } from '../components/export/ExportModalController';
import { EditAccountController } from '../views/administration/accounts/EditAccountController';
import { AddAccountController } from '../views/administration/accounts/AddAccountController';
import { IntradayDetailController } from '../views/accounts/detail/intradays/IntradayDetailController';
import { ValueSeriesController } from '../views/valueseries/valueseries';
import { UiSelectCtrl } from "../components/uiSelect/uiSelectCtrl";
import { ValueSeriesGroupTableController } from '../components/tables/valueseries/valueSeriesGroupTable.directive';
import { CommonViewController } from '../controller/CommonViewController';
import { AddUserReportController } from "../views/administration/userReports/AddUserReportController";
import { EditUserReportController } from "../views/administration/userReports/EditUserReportController";
import { GroupDetailController } from "../views/administration/accountGroups/GroupDetailController";

export class Controllers {

    /** @ngInject */
    constructor(arswebModule) {
        this.arswebModule = arswebModule;
    }

    defineControllers() {
        this.arswebModule.controller('fsLoginController', fsLoginController)
            .controller('MainController', MainController)
            .controller('AddGroupController', AddGroupController)
            .controller('arsAccountsController', arsAccountsController)
            .controller('DashBoardController', DashBoardController)
            .controller('AccountController', AccountController)
            .controller('StatementController', StatementController)
            .controller('DeleteConfirmationController', DeleteConfirmationController)
            .controller('ConfirmationModalController', ConfirmationModalController)
            .controller('SendReportingDeleteConfirmationController', SendReportingDeleteConfirmationController)
            .controller('ReportModalController', ReportModalController)
            .controller('ExportModalController', ExportModalController)
            .controller('EditAccountController', EditAccountController)
            .controller('AddAccountController', AddAccountController)
            .controller('IntradayDetailController', IntradayDetailController)
            .controller('ValueSeriesController', ValueSeriesController)
            .controller('ValueSeriesGroupTableController', ValueSeriesGroupTableController)
            .controller('UiSelectCtrl', UiSelectCtrl)
            .controller('CommonViewController', CommonViewController)
            .controller('AddUserReportController', AddUserReportController)
            .controller('EditUserReportController', EditUserReportController)
            .controller('GroupDetailController', GroupDetailController);
    }
}
